var map = {
	"./AbstractWidget": 107,
	"./AbstractWidget.js": 107,
	"./CarrouselWidget": 1442,
	"./CarrouselWidget.css": 2104,
	"./CarrouselWidget.js": 1442,
	"./HotelBook": 1446,
	"./HotelBook.css": 1447,
	"./HotelBook.js": 1446,
	"./ImageWidget": 1452,
	"./ImageWidget.css": 1453,
	"./ImageWidget.js": 1452,
	"./NewsItemWidget": 1265,
	"./NewsItemWidget.css": 1454,
	"./NewsItemWidget.js": 1265,
	"./NewsWidget": 1455,
	"./NewsWidget.css": 3067,
	"./NewsWidget.js": 1455,
	"./PopUpImageWidget": 1456,
	"./PopUpImageWidget.css": 1457,
	"./PopUpImageWidget.js": 1456
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1253;


//////////////////
// WEBPACK FOOTER
// ./src/cms/widgets ^\.\/.*$
// module id = 1253
// module chunks = 0